var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { StyledArticlePageWrapper, StyledPaper, StyledTitle } from "./styled";
import ReactMarkdown from 'react-markdown';
import { useIntl } from "react-intl";
import { Skeleton } from "@mui/material";
import { useLanguage } from "@/context/LanguageContext";
var Article = function (_a) {
    var pageName = _a.pageName;
    var intl = useIntl();
    var language = useLanguage().language;
    var _b = useState(''), content = _b[0], setContent = _b[1];
    var _c = useState(true), loading = _c[0], setLoading = _c[1];
    useEffect(function () {
        setLoading(true);
        var fileMap = {
            welcome: 'welcome.md',
            cancellationPolicy: 'cancellationPolicy.md',
            integrations: 'integrations.md',
            termsOfService: 'sahlTermsOfService.md',
            cookiesPolicy: 'sahlCookiesPolicy.md',
            privacyAndSecurity: 'sahlPrivacyAndSecurityPolicy.md',
            pricingPlans: 'pricingPlans.md',
            faqTaxableIncome: 'faq/determinationOfTaxableIncome.md',
            faqReliefGuide: 'faq/smallBusinessReliefGuide.md',
            faqBankStatementProcessing: 'faq/bankStatementProcessing.md',
            faqTaxImplications: 'faq/UAECorporateTaxImplications.md',
            faqBestSoftware: 'faq/bestAccountingSoftwareUAE.md',
            faqReferal: 'faq/referal.md',
            whySahlTax: 'whySahlTax.md',
            whySahlTaxVsAgencies: 'whySahlTaxVsAgencies.md',
        };
        var loadContent = function () { return __awaiter(void 0, void 0, void 0, function () {
            var module, err_1, fallbackModule, fallbackErr_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 7, 8]);
                        return [4 /*yield*/, import("@/content/".concat(language, "/").concat(fileMap[pageName]))];
                    case 1:
                        module = _a.sent();
                        setContent(module.default);
                        return [3 /*break*/, 8];
                    case 2:
                        err_1 = _a.sent();
                        console.warn("Content not found for ".concat(pageName, " in ").concat(language, ", falling back to English"));
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, import("@/content/en/".concat(fileMap[pageName]))];
                    case 4:
                        fallbackModule = _a.sent();
                        setContent(fallbackModule.default);
                        return [3 /*break*/, 6];
                    case 5:
                        fallbackErr_1 = _a.sent();
                        console.error("Content load failed for ".concat(pageName), fallbackErr_1);
                        setContent('Content not available.');
                        return [3 /*break*/, 6];
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        }); };
        loadContent();
    }, [pageName, language]);
    var title = intl.formatMessage({ id: "title.".concat(pageName) });
    return _jsxs(StyledArticlePageWrapper, { children: [_jsx(StyledTitle, { children: title }), _jsx(StyledPaper, { children: loading ? (_jsxs(_Fragment, { children: [_jsx(Skeleton, { variant: "text", width: "60%", height: 32 }), _jsx(Skeleton, { variant: "text" }), _jsx(Skeleton, { variant: "text" }), _jsx(Skeleton, { variant: "text", width: "80%" }), _jsx(Skeleton, { variant: "text" })] })) : (_jsx(ReactMarkdown, { components: {
                        p: function (_a) {
                            var node = _a.node, props = __rest(_a, ["node"]);
                            return _jsx("p", __assign({ style: { marginTop: '10px' } }, props));
                        },
                        h1: function (_a) {
                            var node = _a.node, props = __rest(_a, ["node"]);
                            return _jsx("h1", __assign({ style: { lineHeight: '1.1em' } }, props));
                        },
                        h2: function (_a) {
                            var node = _a.node, props = __rest(_a, ["node"]);
                            return _jsx("h2", __assign({ style: { marginTop: '20px' } }, props));
                        },
                        h3: function (_a) {
                            var node = _a.node, props = __rest(_a, ["node"]);
                            return _jsx("h3", __assign({ style: { marginTop: '10px' } }, props));
                        },
                        h4: function (_a) {
                            var node = _a.node, props = __rest(_a, ["node"]);
                            return _jsx("h4", __assign({ style: { marginTop: '10px' } }, props));
                        },
                        h5: function (_a) {
                            var node = _a.node, props = __rest(_a, ["node"]);
                            return _jsx("h5", __assign({ style: { marginTop: '10px' } }, props));
                        },
                        h6: function (_a) {
                            var node = _a.node, props = __rest(_a, ["node"]);
                            return _jsx("h6", __assign({ style: { marginTop: '10px' } }, props));
                        },
                        a: function (_a) {
                            var node = _a.node, href = _a.href, children = _a.children, props = __rest(_a, ["node", "href", "children"]);
                            var isInternalLinks = (href === null || href === void 0 ? void 0 : href.startsWith('https://docs.sahl.tax')) || (href === null || href === void 0 ? void 0 : href.includes('@'));
                            return (_jsx("a", __assign({ href: href }, props, { target: isInternalLinks ? undefined : '_blank', rel: isInternalLinks ? undefined : 'noopener noreferrer', children: children })));
                        }
                    }, children: content })) })] });
};
export default Article;
